const textProps = {
  headingbadge: {
    title: "Our Services",
    text:
      "We believe in changing how consulting firms, freelancers, and outsourcing companies do business by making it easier to manage their businesses and stick to a budget.",
    alignment: "center",
  },
  infoAreas: [
    {
      icon: "fas fa-code",
      color: "lightBlue",
      title: "Software Development",
      description: "Transform ideas into innovative software solutions, accelerate time-to-market, and gain a competitive edge.",
      link: {
        to: "/software-development",
        text: "Learn more about our Software Development services",
      },
      width: "1/3",
    },
    {
      icon: "fas fa-globe",
      color: "lightBlue",
      title: "Web Development",
      description: "Boost your online presence, attract and convert customers, and stay ahead with our web development expertise.",
      link: {
        to: "/web-development",
        text: "Discover our Web Development expertise",
      },
      width: "1/3",
    },
    {
      icon: "fas fa-rocket",
      color: "lightBlue",
      title: "Start-up Software Development",
      description: "Tailored software, mobile app, and website solutions for startups, using the latest tools and technologies. We specialize in MVPs, prototypes, and custom development.",
      link: {
        to: "/startup-software-development",
        text: "Partner with us for Start-up Software Development",
      },
      width: "1/3",
    },
    {
      icon: "fas fa-users",
      color: "lightBlue",
      title: "Dedicated Development Team",
      description: "A dedicated team of skilled professionals focused exclusively on your project, ensuring its success and meeting your specific needs.",
      link: {
        to: "/dedicated-development-team",
        text: "Build your Dedicated Development Team",
      },
      width: "1/3",
    },
    {
      icon: "fas fa-mobile-alt",
      color: "lightBlue",
      title: "Mobile Development",
      description: "User-friendly, accessible, and engaging mobile and cross-platform apps to increase customer satisfaction and drive engagement.",
      link: {
        to: "/mobile-development",
        text: "Explore our Mobile Development services",
      },
      width: "1/3",
    },
    {
      icon: "fas fa-cloud",
      color: "lightBlue",
      title: "DevOps & Cloud Engineering",
      description: "Streamline your software development lifecycle and infrastructure management with our DevOps and cloud solutions.",
      link: {
        to: "/devops-cloud-engineering",
        text: "Learn more about DevOps & Cloud Engineering",
      },
      width: "1/3",
    },
    {
      icon: "fas fa-building",
      color: "lightBlue",
      title: "Enterprise Development",
      description: "Transform your enterprise with innovative, scalable, and user-friendly software solutions designed to enhance productivity and drive growth.",
      link: {
        to: "/enterprise-development",
        text: "Read more about our Enterprise Development solutions",
      },
      width: "1/3",
    },
    {
      icon: "fas fa-bug",
      color: "lightBlue",
      title: "Quality Assurance",
      description: "Ensure high quality, bug-free products and services with faster time-to-market, improved efficiency, and a stronger competitive edge.",
      link: {
        to: "/quality-assurance",
        text: "Discover our Quality Assurance processes",
      },
      width: "1/3",
    },
  ]
  
};
export default textProps;
